module.exports = __webpack_public_path__ + "static/media/product.4780d258.png";